import type { ReactNode } from 'react';
import { usePortalPermissions } from '../auth/usePortalPermissions';

export interface PermissionGateProps {
  /** Required permission code(s). All must match unless `mode="any"`. */
  permission: string | string[];
  mode?: 'all' | 'any';
  fallback?: ReactNode;
  children: ReactNode;
}

/** Hide children unless the current portal user has the required permission(s). */
export function PermissionGate({
  permission,
  mode = 'all',
  fallback = null,
  children,
}: PermissionGateProps) {
  const { hasPermission, loading } = usePortalPermissions();

  if (loading) return null;

  const required = Array.isArray(permission) ? permission : [permission];
  const ok =
    mode === 'any'
      ? required.some((p) => hasPermission(p))
      : required.every((p) => hasPermission(p));

  if (!ok) return <>{fallback}</>;
  return <>{children}</>;
}

export default PermissionGate;
